export default __webpack_public_path__ + "static/media/button_point-off.13381035.svg";